import { render, staticRenderFns } from "./languageSelect.vue?vue&type=template&id=75c660c0&"
import script from "./languageSelect.vue?vue&type=script&lang=js&"
export * from "./languageSelect.vue?vue&type=script&lang=js&"
import style0 from "./languageSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports